import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import gallery1 from "../../../assets/scholars/img_1.jpg";
import gallery2 from "../../../assets/scholars/img_2.jpg";
import gallery3 from "../../../assets/scholars/img_3.jpg";
import gallery4 from "../../../assets/scholars/img_4.jpg";
import gallery5 from "../../../assets/scholars/img_5.jpg";
import gallery6 from "../../../assets/scholars/img_6.jpg";
import gallery7 from "../../../assets/scholars/img_7.jpg";
import gallery8 from "../../../assets/scholars/img_8.jpg";
import gallery9 from "../../../assets/scholars/img_9.jpg";
import gallery10 from "../../../assets/scholars/img_10.jpg";
import gallery11 from "../../../assets/scholars/img_11.jpg";
import gallery12 from "../../../assets/scholars/img_12.jpg";
import gallery13 from "../../../assets/scholars/img_13.jpg";
import gallery14 from "../../../assets/scholars/img_14.jpg";
import gallery15 from "../../../assets/scholars/img_15.jpg";
import gallery16 from "../../../assets/scholars/img_16.jpg";
import gallery17 from "../../../assets/scholars/img_17.jpg";
import gallery18 from "../../../assets/scholars/img_18.jpg";
import gallery19 from "../../../assets/scholars/img_19.jpg";
import gallery20 from "../../../assets/scholars/img_20.jpg";
import gallery21 from "../../../assets/scholars/img_21.jpg";
import gallery22 from "../../../assets/scholars/img_22.jpg";
import gallery23 from "../../../assets/scholars/img_23.jpg";
import gallery24 from "../../../assets/scholars/img_24.jpg";

const Gallery = () => {
  const theme = useTheme();

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
    gallery23,
    gallery24,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box>
      <Box marginTop={{ xs: "25%", sm: "5%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "26vh" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"oof_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "24%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
    </Box>
  );
};

export default Gallery;
